import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Bloque l'accès aux visiteurs non connectés et aux comptes pas encore validés par un admin
const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { currentUser, profile } = useAuth();

  if (!currentUser) {
    return <Navigate to="/connexion" replace />;
  }

  if (!profile?.approved) {
    return (
      <div className="membres-container">
        <h2>Compte en attente de validation</h2>
        <p>Un administrateur de la troupe doit approuver votre compte avant que vous puissiez accéder à cet espace.</p>
      </div>
    );
  }

  if (adminOnly && !profile?.is_admin) {
    return <Navigate to="/espace-membres" replace />;
  }

  return children;
};

export default ProtectedRoute;
